import React, { useEffect, useReducer } from "react";
import { Row, Col, Table } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { withHeaderMessages } from "../higherOrderComponents/WithHeaderMessages";
import { Currency } from "../lib/components/Currency";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from "../lib/components/LoadingSpinner";
import { FormattedDate } from "../lib/components/FormattedDate";
import qs from "qs";

const PaymentHistory = (props) => {
  const location = useLocation();

  const { n } = qs.parse(location.search, { ignoreQueryPrefix: true });

  const initialState = {
    contractsQueryString: n,
    contractNumbers: n.split(",") || [],
    isLoadingPayments: true,
    paging: {
      page: 1,
      pageSize: 2147483647,
    },
    payments: [],
    contract: {
      provider: {},
    },
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "payments":
        return {
          ...state,
          payments: action.payload,
          isLoadingPayments: false,
        };
      case "contracts":
        return {
          ...state,
          contracts: action.payload,
          isLoadingPayments: false,
        };
      case "isLoading":
        return {
          ...state,
          isLoading: action.payload,
        };
      case "hideLoader":
        return {
          ...state,
          isLoading: false,
        };
      default:
        throw new Error();
    }
  };

  const [paymentHistoryState, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    async function getPaymentHistory() {
      const { contractNumbers } = paymentHistoryState;
      //not sure if paging is prsent in props
      const { paging } = props;
      let pagingQueryString = qs.stringify(paging, {
        allowDots: true,
        encode: false,
        addQueryPrefix: true,
      });
      await Promise.all(
        contractNumbers.map((n) =>
          props.api
            .get(`/api/contract/${n}/payment-history` + pagingQueryString)
            .then((response) => {
              if (response.status === 200) {
                return response.data;
              } else {
                throw new Error("Api Error");
              }
            }),
        ),
      )
        .catch(() => dispatch({ type: "isLoading", payload: false }))
        .then((data) => {
          data.sort((a, b) => a.contractNumber.localeCompare(b.contractNumber));
          dispatch({ type: "payments", payload: data });
        });
    }
    getPaymentHistory();
  }, []);

  useEffect(() => {
    async function getPaymentHistory() {
      const { contractNumbers } = paymentHistoryState;
      await Promise.all(
        contractNumbers.map((n) =>
          props.api.get(`/api/contract/${n}`).then((response) => {
            if (response.status === 200) {
              return response.data;
            } else {
              throw new Error("Api Error");
            }
          }),
        ),
      )
        .catch(() => dispatch({ type: "isLoading", payload: false }))
        .then((data) => {
          data.sort((a, b) => a.number.localeCompare(b.number));
          dispatch({ type: "contracts", payload: data });
        });
    }
    getPaymentHistory();
  }, []);

  const renderPayments = (paymentDetails, index) => {
    const contractNumber = paymentDetails?.contractNumber;
    const payments = paymentDetails?.results;
    const recipientLabel =
      paymentDetails?.recipients && paymentDetails?.recipients.length > 1
        ? "Recipients"
        : "Recipient";
    const pageBreakBefore = index > 0 ? "always" : "auto";

    const contract = contracts?.find((c) => c.number === contractNumber);
    const customLogo = contract?.provider?.providerLogo;

    return (
      <>
        <Row style={{ pageBreakBefore: `${pageBreakBefore}` }}>
          {customLogo ? (
            <Col xs={12} className="logo-container">
              <div className="receipt-header__inner justify-content-center">
                <div className="receipt-header__logo-wrap">
                  <img
                    src={`data:${customLogo.contentType};base64,${customLogo.logoBase64}`}
                    alt="Customer logo"
                    className="receipt-header__logo__bigger"
                  />
                </div>
              </div>
            </Col>
          ) : (
            <Col xs={12} style={{ textAlign: "center" }}>
              <img
                className="logo"
                src="/images/ClearPoint-Logo@3x.png"
                alt="ClearPoint logo"
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col sm={12}>
            <h4 className="mr-15 text-start mt-2">
              Contract {contractNumber} - Payment History
            </h4>
          </Col>
        </Row>
        {paymentDetails.providerContractNumber && (
          <Row>
            <Col sm={6}>
              <span>
                Provider Contract Number:{" "}
                {paymentDetails.providerContractNumber}
              </span>
            </Col>
          </Row>
        )}
        {paymentDetails.purchaser && (
          <Row>
            <Col sm={6}>
              <span>Purchaser: {paymentDetails.purchaser}</span>
            </Col>
          </Row>
        )}
        {paymentDetails.recipients && paymentDetails.recipients.length > 0 && (
          <Row>
            <Col sm={6}>
              <span>
                {recipientLabel}: {paymentDetails.recipients.join(", ")}
              </span>
            </Col>
          </Row>
        )}
        {payments.length === 0 ? (
          <p>There are no payments for this contract.</p>
        ) : (
          <>
            <Row>
              <Col sm={12}>
                <Table className="table-striped">
                  <thead>
                    <tr>
                      <th>Transaction Date</th>
                      <th>Description</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payments.map((p) => (
                      <tr key={p.posted + p.description}>
                        <td>
                          <FormattedDate date={p.posted} />
                        </td>
                        <td>{p.description}</td>
                        <td>
                          <Currency amount={p.amount} />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={2} style={{ textAlign: "right" }}>
                        Total
                      </td>
                      <td>
                        <Currency
                          amount={payments.reduce(
                            (total, current) => total + current.amount,
                            0,
                          )}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </>
        )}
      </>
    );
  };

  if (paymentHistoryState.isLoadingPayments) {
    return <LoadingSpinner />;
  }
  const { payments, contracts } = paymentHistoryState;

  return payments.map((payment, i) => renderPayments(payment, i, contracts));
};

export default withHeaderMessages(WithApiAccess(PaymentHistory));
